@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.wrapper {
  display: flex;
  align-items: center;
  column-gap: 5px;
  min-width: 142px;

  &.sm {
    min-width: 100px;
  }
}
